export const PREF_CHANGED_EVENT = 'teamchat:notification-pref-changed';

export const BROWSER_NOTIFICATIONS_STORAGE_KEY = 'teamChat.browserNotificationsEnabled';
export const SOUND_NOTIFICATIONS_STORAGE_KEY = 'teamChat.soundNotificationsEnabled';
